import {
  FETCH_MANUFACTURER_CODE_SUCCESS,
  SORT_MANUFACTURER_CODE_LIST,
  MANUFACTURER_CODE_FILTER,
  MANUFACTURER_CODE_CLEAR_FILTER,
} from "../actions/types";

const INITIAL_STATE = {
  list: [],
  filters: {
    active: true,
    manufacturerCode: "",
    createdAt: {
      from: null,
      to: null,
    },
  },
  sorting: {
    orderBy: "createdAt",
    sort: "desc",
  },
  manufacturerCodeCreateDialog: {
    open: false,
    entity: null,
  },
};

const manufacturerCodeReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_MANUFACTURER_CODE_SUCCESS:
      return {
        ...state,
        list: action.payload,
      };
    case SORT_MANUFACTURER_CODE_LIST:
      return {
        ...state,
        sorting: action.payload,
      };
    case MANUFACTURER_CODE_FILTER:
      return {
        ...state,
        filters: {
          ...state.filters,
          [action.payload.filterKey]: action.payload.filterValue,
        },
      };
    case MANUFACTURER_CODE_CLEAR_FILTER:
      return {
        ...state,
        filters: {
          active: true,
          manufacturerCode: "",
          createdAt: {
            from: null,
            to: null,
          },
        },
      };
    default:
      return state;
  }
};

export default manufacturerCodeReducer;
